import React from "react";

import { isButton, isButtonLink } from "../../../../../../../../utils/isButton";
import { SharedButtonProps } from "../../../../../../../controls/Button";
import Button, {
  ButtonProps
} from "../../../../../../../controls/Button/Button";
import ButtonLink, {
  ButtonLinkProps
} from "../../../../../../../controls/ButtonLink/ButtonLink";

export type ModalButtonProps = (
  | Pick<ButtonProps, "onClick">
  | Pick<ButtonLinkProps, "to" | "newTab" | "replace" | "onClick">
) &
  Pick<SharedButtonProps, "children" | "disabled" | "loading" | "tone">;

export default function ModalButton(
  props: { cta: "primary" | "secondary" } & ModalButtonProps
) {
  const { cta, ...modalButtonProps } = props;

  const fill = cta === "primary" ? "filled" : "outlined";

  if (isButton(modalButtonProps)) {
    return <Button {...modalButtonProps} fill={fill} width="100%" />;
  }

  if (isButtonLink(modalButtonProps)) {
    return <ButtonLink {...modalButtonProps} fill={fill} width="100%" />;
  }

  return null;
}
